import React from "react";

/**
 * Full-screen overlay shown when a user enters Door 2 late and their
 * band needs waking up (30-second GREEN command + countdown).
 *
 * Props:
 *   show         — boolean, whether the overlay is visible
 *   secondsLeft  — countdown remaining
 *   onDismiss    — called when user taps "I'm not using my band for this show"
 */
export default function BandWakeUpOverlay({ show, secondsLeft, onDismiss }) {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9998,
        background: "rgba(0, 0, 0, 0.88)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Lato, sans-serif",
        color: "#fff",
        textAlign: "center",
        padding: "40px 28px",
      }}
    >
      {/* Pulsing green circle */}
      <div
        style={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          background: "radial-gradient(circle, #3adf3c 0%, #1a8c1d 100%)",
          boxShadow: "0 0 40px rgba(58, 223, 60, 0.6)",
          marginBottom: 32,
          animation: "beaconPulse 1.5s ease-in-out infinite",
        }}
      />

      <div style={{ fontSize: 26, fontWeight: 700, marginBottom: 12 }}>
        Preparing Your Bands For the Show...
      </div>
      <div style={{ fontSize: 20, opacity: 0.85, marginBottom: 32, maxWidth: 420 }}>
        Get ready for an interactive fireworks experience!
      </div>

      {/* Countdown */}
      <div
        style={{
          fontSize: 48,
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
          marginBottom: 40,
        }}
      >
        {secondsLeft}s
      </div>

      {/* Dismiss button */}
      <button
        onClick={onDismiss}
        style={{
          background: "transparent",
          border: "2px solid rgba(255,255,255,0.5)",
          borderRadius: 12,
          color: "rgba(255,255,255,0.7)",
          fontSize: 16,
          padding: "12px 28px",
          cursor: "pointer",
          fontFamily: "Lato, sans-serif",
          transition: "border-color 0.2s, color 0.2s",
        }}
      >
        I'm not using my band for this show
      </button>

      {/* Pulse keyframes injected inline */}
      <style>{`
        @keyframes beaconPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.15); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
}
